import { default as React, useState, useContext, useEffect, useCallback, useMemo } from 'react'
import { useNavigate, useSearchParams  } from 'react-router-dom'
import { Factory } from '@mui/icons-material'
import ListOwnerships from './ListOwnerships'

import ListViewCommandBar from '../commandBar/ListViewCommandBar'
import Page from '../layout/Page'
import { ROLES } from '../auth/role'
import RoleContext from '../auth/RoleContext'
import { Paper } from '@mui/material'
import TabPanel from '../form/TabPanel'
import { useLocalStorage } from '../utils/ReactUtils'

export default function ListOwnershipsPage (props = {}) {
  const roleDetails = useContext(RoleContext)
  const [isLoading, setIsLoading] = useState(true)
  const [selectedTab, setSelectedTab] = useState(0)
  const [searchParams, setSearchParams] = useSearchParams({ view: 'active', page: '1'})
  const navigate = useNavigate()

  const startLoading = useCallback(() => {
    setIsLoading(true)
  }, [])

  const stopLoading = useCallback(() => {
    setIsLoading(false)
  }, [])

  const breadcrumb = <span><Factory/>&nbsp;Ownerships</span>

  const [showFilters, setShowFilters] = useLocalStorage("showFilters", false)
  const toggleFilters = useCallback(() => {
    setShowFilters(!showFilters);
  }, [setShowFilters, showFilters])

  const addRecord = useCallback(() => {
    navigate('/ownership/create')
  }, [navigate])

  const tabChange = useCallback((event, toTab) => {
    setSearchParams({view: toTab === 1 ? 'inactive' : 'active'})
  }, [setSearchParams])

  const activeSearchFilter = useMemo(() => ({ isActive: true }), [])
  const inactiveSearchFilter = useMemo(() => ({ isActive: false }), [])

  useEffect(() => {
    setSelectedTab(searchParams.get('view') === 'inactive' ? 1 : 0)
  }, [searchParams])

  return (
    <Page { ...props} breadcrumb={breadcrumb} isLoading={isLoading} 
      commandBar={
        <ListViewCommandBar 
          showFilters={true}
          filtersEnabled={showFilters}
          toggleFilters={toggleFilters} 
          addRecord={addRecord} 
          showAdd={roleDetails.isQualityManager()}  
        />
      }>
        <Paper sx={{margin: '0 auto 1em auto' }}>
          { (roleDetails.isInternalUser() || roleDetails.hasRole([ROLES.IM_MANAGER])) && 
            <TabPanel panelId='facilities' key='facilities' tabs={[
              {
                key: 'active',
                label: 'Active',
                el: (
                <ListOwnerships showFilters={showFilters} startLoading={startLoading} stopLoading={stopLoading} searchFilter={activeSearchFilter} />
                )
              },
              {
                key: 'inactive',
                label: 'Inactive',
                el: (
                  <ListOwnerships showFilters={showFilters} startLoading={startLoading} stopLoading={stopLoading} searchFilter={inactiveSearchFilter} />
                )
              }
            ]} tabStyle={{ textTransform: 'none', minHeight: 'unset'}}
              defaultTab={selectedTab}
              onTabChange={(idx) => tabChange(null, idx)}
            />
          }
          { roleDetails.isBottlerUser() && 
            <ListOwnerships showFilters={showFilters} startLoading={startLoading} stopLoading={stopLoading} searchFilter={activeSearchFilter} />
          }
        </Paper>
    </Page>
  )
}